var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 45.255,
    height: 45.255,
    viewBox: "0 0 45.255 45.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_icon",
    "data-name": "close icon",
    d: "M15.332,32a1.125,1.125,0,0,1-1.125-1.125V19.207H1.125A1.125,1.125,0,0,1,0,18.082V15.332a1.125,1.125,0,0,1,1.125-1.125H14.207V1.125A1.125,1.125,0,0,1,15.332,0h2.749a1.125,1.125,0,0,1,1.125,1.125V14.207H30.875A1.125,1.125,0,0,1,32,15.332v2.749a1.125,1.125,0,0,1-1.125,1.125H19.207V30.875A1.125,1.125,0,0,1,18.082,32Z",
    transform: "translate(22.628) rotate(45)",
    fill: "#191919"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClose);
export default __webpack_public_path__ + "static/media/black-close.b726e8755a498a98c89119961343a252.svg";
export { ForwardRef as ReactComponent };